/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_QUESTIONS } from "./actionTypes"
import { apiError, listQuestionsSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getQuestions } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(getQuestions, request.payload.idExam)
    if (response == undefined) throw new Error("API error")
    yield put(listQuestionsSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* questionsListSaga() {
  yield takeEvery(LIST_QUESTIONS, list)
}

export default questionsListSaga
